import apiClient from "@/services/apiClient";

const createNotificationService = (basePath) => ({
  async getAll() {
    const { data } = await apiClient.get(basePath);
    return {
      unreadCount: Number(data?.unreadCount ?? data?.UnreadCount ?? 0),
      notifications: data?.notifications ?? data?.Notifications ?? [],
    };
  },
  async getUnreadCount() {
    const { data } = await apiClient.get(`${basePath}/unread-count`);
    return Number(data?.unreadCount ?? data?.UnreadCount ?? 0);
  },
  async markRead(notificationId) {
    await apiClient.put(`${basePath}/${notificationId}/read`);
  },
  async markAllRead() {
    await apiClient.put(`${basePath}/read-all`);
  },
});

export const studentNotificationService = createNotificationService("/StudentNotifications");
export const adminNotificationService = createNotificationService("/AdminNotifications");
